import type * as React from "react";

import { cn } from "@ui/lib/utils";
import { type VariantProps, cva } from "class-variance-authority";

const badgeVariants = cva(["inline-flex items-center flex-none justify-center whitespace-nowrap", "rounded-full"], {
  variants: {
    variant: {
      default: "bg-dark",
      strong: "bg-inverse text-inverse",
      inverse: "bg-default text-default",
      positive: "bg-positive text-positive",
      negative: "bg-negative text-negative",
      professional: "bg-yellow",
      outline: "bg-transparent border border-default text-default",
    },
    size: {
      sm: "px-8 py-2 f-ui-04",
      md: "px-8 py-4 f-ui-04",
      lg: "px-20 py-16 f-ui-03",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "md",
  },
});

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { Badge, badgeVariants };
